// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//info.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//upArrow-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images//T_Artboard 21mdpi.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images//q_down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images//downArrow-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images//edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images//Artboard 4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images//delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images//collapsebtn-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images//collapsebtn-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/images//prevPage.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/images//prevPage-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/images//nextPage.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images//nextPage-lexus.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionnaire {
    background-color:white;
    /* margin: -7px; */
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
}
.subQuestionTable {
    margin-top:5rem;
    margin-bottom:0.5rem;
    border: 1px solid #e5e5e5;
}

.scrollbar {
    height:100%;
}

.leftPane {
    max-width:25%;
    flex:0 0 25%;
    padding-left:8px;
    padding-right:10px;
    min-height: 33rem;
}
.rightPane {
    max-width:74%;
    flex:0 0 74%;   
    padding-left:8px;
    padding-right:8px;
    padding-bottom:0.5rem;
}
.leftPaneCollapsed {
    max-width:1.8%;
    flex:0 0 1.8%;
    /* padding-left:15px;
    padding-right:15px; */
}
.rightPaneCollapsed {
    max-width:97%;
    flex:0 0 97%;
    padding-left:15px;
    padding-right:15px;
    min-height:33rem;
}
.additionalInfo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin-right: 7px;
    padding-top:1.8px;
    padding-right:3px;
}

.addP {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
    height: 20px;
    width: 19px;
    background-position: center;
    margin: 0.3rem 0;
    padding-top: 1rem;
    padding-bottom: -1rem;
    padding-right:3px;
    margin-bottom: -0.3rem;
    margin-left: 0.5rem;
}

/* .leftPane {
    display:inline-block;
}

.rightPane {
    display:inline-block;
    width:97%;
    padding-left: 10px !important;
} */

.leftPanelContent {
    width:94%;
    height:100%;
    display:inline-block;
}

.btn-toolbars {
    float:right
}

.mainQuestionSection {
    word-break:break-all;
    border:0.5px #e5e5e5 solid;
    margin-top: 7px !important;
    /* height:25rem; */
}
.Question {
    margin-top:2rem;
}



 .subQuestionTable {
    border:0.5px #e5e5e5 solid;
    /* height:33rem; */
    /*min-height:40vh !important;*/
}
.subQuestiontable tr {
    border-bottom:0px !important;
}
.subQuestiontable {
    margin-top:1rem;
    /* display:block; */
    /* overflow-y: scroll; */
    /* height:30rem; */
}
#tmeTableTME div table thead>tr>th:first-child {
    width: 5.83% !important;
    float: left;
    padding-left:0.3rem !important;
}
.subQuestionTable tbody>tr>td:last-child {
    padding-top:10px !important;
}

/* .subQuestionTable .tmeTable tbody>tr>td:first-child {
    width: 0rem;
    float: left;
} */
.subQuestionTable Table tbody {
    height:27vh;
    overflow: scroll;
} 

.subQuestionTable Table tbody tr td,.subQuestionTable .tmeTable thead tr th{
    padding-top:0.75rem !important;
    padding-left:0.3rem !important;
    padding-right:0rem !important;
    padding-bottom:0.75rem !important;

}  


.mainQuestionWhy,.mainQuestionLibrary {
    margin-left:3.7rem;
    margin-top:-6px;
    text-align:justify;
    border:1px solid #e5e5e5;
    display:block;
    word-break: normal;
}
.mainQuestion {
    margin-top:1rem;
}
.libText {
    margin-top:1rem;
    margin-left:2rem;
}
.upArrow-lexus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat:no-repeat;
    display:inline-block;
}
.upArrow-toyota {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat:no-repeat;
    display:inline-block;
}

.downArrow-toyota {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat:no-repeat;
    display:inline-block;
}

.downArrow-lexus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-repeat:no-repeat;
    display:inline-block;
}

.down-icon-toyota{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat:no-repeat;
    padding:0.2px;
    height: 29px;
    width: 28px;
    display:inline-flex;
}
.down-icon-lexus{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat:no-repeat;
    padding:0.2px;
    height: 29px;
    width: 28px;
    display:inline-flex;
}

.selectedButton-toyota{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat:no-repeat;
    transform: rotate(180deg);
	cursor: pointer;
    padding:0.2px;
    height: 29px;
    width: 28px;
    display:inline-flex;
}
.selectedButton-lexus{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat:no-repeat;
    transform: rotate(180deg);
	cursor: pointer;
    padding:0.2px;
    height: 29px;
    width: 28px;
    display:inline-flex;
}

.buttonHeading-toyota {
    background-color: #e50000;
    border: 1px solid #e50000;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    height: 1.2rem;
    width: 5rem;
    margin-left:2rem;
  }
  
  .buttonHeading-lexus {
    background-color: #252525;
    border: 1px solid #252525;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    height: 1.2rem;
    width: 5rem;
    margin-left:2rem;
  }

  .buttonHeadingWhat-toyota {
    background-color: #e50000;
    border: 1px solid #e50000;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin-left:0rem;
    margin-top:0.7rem;
    width: 5rem;
    float:left;
  }
  
  .buttonHeadingWhat-lexus {
    background-color: #252525;
    border: 1px solid #252525;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin-left:0rem;
    margin-top:0.7rem;
    width: 5rem;
    float:left;
  }

.edit-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    float:right;
    
}

.subQuestionSection {
    margin-top:1.5rem;
    margin-bottom:-1.55rem;
}
.subQuestionAdd {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    height: 25px;
    width: 26px;
    background-position: center;
    float:right;
}
.mainQueAdd {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    /* display:inline-block; */
    float:right;

}
.mainQuestionnaire {
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    display:inline-block;
    padding:1rem;

}
.delete-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    float:right;
    
}
.delete-iconRight {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    display:inline-block;
    float:right;
    padding:1rem;
}
.edit-iconRight {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    display:inline-block;
    /* margin-left:90%; */
    float:right;
    padding:1rem;
}

.questionTitle {
    font-weight:bold;
    margin-top:1rem;
    word-break:normal;
}

.whySection, .librarySection {
    margin-bottom:1rem;
    margin-left:1.5rem;
}

.collapseContainer {
    margin-left:2rem;
    margin-right:1rem;
    margin-top:1rem;
    margin-bottom:1rem;
    white-space: pre-wrap;
}

.collapseContainerLibrary {
    margin-top:1rem;
    white-space: pre-wrap;
}

.libraryLinkContainer {
    max-height:8rem;
    overflow-y:scroll;
}


.linkLibraryModal {
    min-height:412px;
}

.noOfFiles {
    margin-right:7rem !important;
    margin-bottom:37px;
    display:block !important;
}

.questionnaire {
    background-color:white;
    /* max-height:500px; */
}
.rotate-false{
    transform: rotate(0deg) !important;
}
.rotate-true{
    transform: rotate(90deg) !important;
}
.questionSummary {
    height:100%;
}
.questionSummary .treeBeardContainter ul{
    background-color: white !important;
    color:black ;
    font-size: 12px !important;
    font-family: Arial, Helvetica, sans-serif;
}

.questionSummary .treeBeardContainter ul li div {
    background-color: white !important;
    color:black ;
    font-size: 12px !important;
    font-family: Arial, Helvetica, sans-serif;
    /* display:block; */
    height: 100%;

}
.activeQuestion{
      color:#e50000 !important;
}
.treeBeardContainter{
word-wrap: break-word;
height: 93%;

}
#leftPaneModal .modal-content{
      width: 400px !important;
}
.questionSummary ul li{
    margin:15px 10px;
}
/* .leftNavCollapseBtn:hover,.thickRightBorder div.d-flex:hover{
    background-color: #f0f0f0 !important;
}  */
.subQueAdd {
    padding-top:2rem;
}
.leftNavCollapseBtn-toyota{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-color: white; 
    height: 100%;
    cursor: pointer;
    width:14px;
    background-repeat: no-repeat;
    /* margin-left:5px; */
    border:solid 1px #ececec;
    background-position: center;
   
}
.leftNavCollapseBtn-lexus{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-color: white; 
    height: 100%;
    cursor: pointer;
    width:14px;
    background-repeat: no-repeat;
    /* margin-left:5px; */
    border:solid 1px #ececec;
    background-position: center;
   
}
.mainQuestionTools {
    /* margin-top:0.5rem; */
    height:30px;
    padding:5px;
    margin-bottom:-0.1rem;
}
.prevQuestion-toyota {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    height: 18px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
    float:right;
    padding:1rem;
}
.prevQuestion-lexus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    height: 18px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
    float:right;
    padding:1rem;
}
.nextQuestion-toyota {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    height: 18px;   
    background-position: center;
    background-repeat: no-repeat;
    margin-left: 5rem;;
    float:right;
    padding:1rem;
}
.nextQuestion-lexus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    height: 18px;   
    background-position: center;
    background-repeat: no-repeat;
    margin-left: 5rem;;
    float:right;
    padding:1rem;
}

.prevQuestion-disabled-toyota {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    height: 18px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
    float:right;
    padding:1rem;
    cursor:not-allowed;
}

.nextQuestion-disabled-toyota {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    height: 18px;   
    background-position: center;
    background-repeat: no-repeat;
    margin-left: 5rem;;
    float:right;
    padding:1rem;
    cursor:not-allowed;
}
.prevQuestion-disabled-lexus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    height: 18px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
    float:right;
    padding:1rem;
    cursor:not-allowed;
}

.nextQuestion-disabled-lexus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    height: 18px;   
    background-position: center;
    background-repeat: no-repeat;
    margin-left: 5rem;;
    float:right;
    padding:1rem;
    cursor:not-allowed;
}
.questionnaire .leftPane{
    padding-right: 0px !important;
}

#leftPaneModal {
    color:black;
}
#leftPaneModal .modal-header{
    background-color:#e50000;
}

.questionSummaryAction{
    height: 30px;
    border-bottom: 1px solid #e5e5e5;    
    padding:5px;
    /* width: 178px; */

}
.nmscTabs{
    padding : 0rem !important;
    border-width : 0px;
    font-size : 0.75rem;
    position: relative;
    width: 100%
}
.mainQueAddDisabled {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    height: 25px;
    width: 26px;
    cursor:not-allowed;
    background-position: center;
    float:right;
    padding:1rem;
}


.TrailUL {
    column-count : 2;
    column-gap :0;
    list-style-type: none;
    margin-left:-1.5rem;
}

.TrailUL li {
    /* display: inline-block; */
}

.emptyDiv {
    min-height :430px !important;
}

.tableCount {
    /* background-color: #e6e6e6; */
    background-repeat: no-repeat;
    /* background-image: -webkit-linear-gradient(#ffffff, #ffffff 25%, #e6e6e6);
  background-image: linear-gradient(#ffffff, #ffffff 25%, #e6e6e6); */
    color: #202020;
    font-size: 12px;
    line-height: normal;
    font-weight: normal;
    text-align: center;
    font-weight: bold;
    border-collapse: separate !important;
    border-collapse: initial !important;
    border: none !important;
   }
/* .tmeTable thead > tr > th:first-child {
    width:3rem !important;
} */
.tableCount th{
    font-size: 12px;
    border: none !important;
    padding-bottom: none !important;
    padding-top: none !important;
}

.tableCount tr{
    font-size: 12px;
    border: none !important;
}
.libLinkRightPanel {
    width: 62%;
    /* border: 1px solid lightgrey; */
    min-height: 400px!important;
}
.viewLibraries {
    padding:1rem;
    border: 0.5px solid lightgrey;
}
.nmscTabs .nav-tabs .nav-item{
    width:18% !important;
}

.nmscTabs.toyota .nav-tabs .nav-item a{
    border-color:transparent !important;
    color:black!important;
}

.nmscTabs.toyota .nav-tabs .nav-item a.nav-link.active{    
    color:#e50000 !important;    
}

.nmscTabs.lexus .nav-tabs .nav-item a{
    border-color:transparent !important;
}

.nmscTabs.lexus .nav-tabs .nav-item a.nav-link.active{
    color:black !important;
}

.nmscTabs .nav-tabs li.nav-item:first-child {
    width:35% !important;
}


/* .leftPane.leftNav{
    height:604px !important;
}
.rightPane{
    height:604px !important; 
}
.kpiTableContainer .tabs .nav.nav-tabs{
    height:36px !important;
} */
/* .publishPanel{
    position: absolute;
    width: 100%;
    bottom: 23px;
} */
/* .rightPane{
    position: relative;
    min-height: 779px
}
.leftPane .leftNav{
    min-height: 779px
}
.questionSummary{
    min-height: 770px;
} */
/* mainQuestionContent-isNmsc{
    min-height: 900px;
} */`, "",{"version":3,"sources":["webpack://./src/components/questionnaire/index.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,aAAa;IACb;yBACqB;AACzB;AACA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,SAAS;IACT,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;;;;CAIC;IACG,0BAA0B;IAC1B,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,8BAA8B;AAClC;AACA;IACI,2BAA2B;AAC/B;;AAEA;;;GAGG;AACH;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,iCAAiC;;AAErC;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yDAA+D;IAC/D,2BAA2B;IAC3B,oBAAoB;AACxB;AACA;IACI,yDAAmE;IACnE,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,yDAAwD;IACxD,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,yDAAiE;IACjE,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,yDAAmE;IACnE,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,yDAA+D;IAC/D,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yDAAmE;IACnE,2BAA2B;IAC3B,yBAAyB;CAC5B,eAAe;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,yDAA+D;IAC/D,2BAA2B;IAC3B,yBAAyB;CAC5B,eAAe;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,UAAU;EACZ;;AAEF;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;;AAEf;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;;AAEf;AACA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;;AAEhB;AACA;IACI,yDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;;AAEf;AACA;IACI,yDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB;AACA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;AACA;IACI,kCAAkC;IAClC,YAAY;IACZ,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,0BAA0B;IAC1B,yCAAyC;IACzC,mBAAmB;IACnB,YAAY;;AAEhB;AACA;MACM,wBAAwB;AAC9B;AACA;AACA,qBAAqB;AACrB,WAAW;;AAEX;AACA;MACM,uBAAuB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI;AACJ;IACI,gBAAgB;AACpB;AACA;IACI,yDAAoE;IACpE,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,4BAA4B;IAC5B,qBAAqB;IACrB,wBAAwB;IACxB,2BAA2B;;AAE/B;AACA;IACI,yDAAmE;IACnE,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,4BAA4B;IAC5B,qBAAqB;IACrB,wBAAwB;IACxB,2BAA2B;;AAE/B;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,0DAA0D;IAC1D,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,0DAAgE;IAChE,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,0DAA0D;IAC1D,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;AACA;IACI,0DAAgE;IAChE,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0DAA0D;IAC1D,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,0DAA0D;IAC1D,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,0DAAgE;IAChE,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,0DAAgE;IAChE,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,WAAW;IACX,kBAAkB;;AAEtB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;AACA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B;qEACiE;IACjE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,oCAAmC;IAAnC,mCAAmC;IACnC,uBAAuB;GACxB;AACH;;GAEG;AACH;IACI,eAAe;IACf,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,iCAAiC;IACjC,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;;AAGA;;;;;;;;GAQG;AACH;;;;GAIG;AACH;;;;;;;;;GASG;AACH;;GAEG","sourcesContent":[".questionnaire {\n    background-color:white;\n    /* margin: -7px; */\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n}\n.subQuestionTable {\n    margin-top:5rem;\n    margin-bottom:0.5rem;\n    border: 1px solid #e5e5e5;\n}\n\n.scrollbar {\n    height:100%;\n}\n\n.leftPane {\n    max-width:25%;\n    flex:0 0 25%;\n    padding-left:8px;\n    padding-right:10px;\n    min-height: 33rem;\n}\n.rightPane {\n    max-width:74%;\n    flex:0 0 74%;   \n    padding-left:8px;\n    padding-right:8px;\n    padding-bottom:0.5rem;\n}\n.leftPaneCollapsed {\n    max-width:1.8%;\n    flex:0 0 1.8%;\n    /* padding-left:15px;\n    padding-right:15px; */\n}\n.rightPaneCollapsed {\n    max-width:97%;\n    flex:0 0 97%;\n    padding-left:15px;\n    padding-right:15px;\n    min-height:33rem;\n}\n.additionalInfo {\n    background-image: url(\"../../assets/images//info.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin-right: 7px;\n    padding-top:1.8px;\n    padding-right:3px;\n}\n\n.addP {\n    background-image: url(\"../../assets/images//info.png\"); \n    height: 20px;\n    width: 19px;\n    background-position: center;\n    margin: 0.3rem 0;\n    padding-top: 1rem;\n    padding-bottom: -1rem;\n    padding-right:3px;\n    margin-bottom: -0.3rem;\n    margin-left: 0.5rem;\n}\n\n/* .leftPane {\n    display:inline-block;\n}\n\n.rightPane {\n    display:inline-block;\n    width:97%;\n    padding-left: 10px !important;\n} */\n\n.leftPanelContent {\n    width:94%;\n    height:100%;\n    display:inline-block;\n}\n\n.btn-toolbars {\n    float:right\n}\n\n.mainQuestionSection {\n    word-break:break-all;\n    border:0.5px #e5e5e5 solid;\n    margin-top: 7px !important;\n    /* height:25rem; */\n}\n.Question {\n    margin-top:2rem;\n}\n\n\n\n .subQuestionTable {\n    border:0.5px #e5e5e5 solid;\n    /* height:33rem; */\n    /*min-height:40vh !important;*/\n}\n.subQuestiontable tr {\n    border-bottom:0px !important;\n}\n.subQuestiontable {\n    margin-top:1rem;\n    /* display:block; */\n    /* overflow-y: scroll; */\n    /* height:30rem; */\n}\n#tmeTableTME div table thead>tr>th:first-child {\n    width: 5.83% !important;\n    float: left;\n    padding-left:0.3rem !important;\n}\n.subQuestionTable tbody>tr>td:last-child {\n    padding-top:10px !important;\n}\n\n/* .subQuestionTable .tmeTable tbody>tr>td:first-child {\n    width: 0rem;\n    float: left;\n} */\n.subQuestionTable Table tbody {\n    height:27vh;\n    overflow: scroll;\n} \n\n.subQuestionTable Table tbody tr td,.subQuestionTable .tmeTable thead tr th{\n    padding-top:0.75rem !important;\n    padding-left:0.3rem !important;\n    padding-right:0rem !important;\n    padding-bottom:0.75rem !important;\n\n}  \n\n\n.mainQuestionWhy,.mainQuestionLibrary {\n    margin-left:3.7rem;\n    margin-top:-6px;\n    text-align:justify;\n    border:1px solid #e5e5e5;\n    display:block;\n    word-break: normal;\n}\n.mainQuestion {\n    margin-top:1rem;\n}\n.libText {\n    margin-top:1rem;\n    margin-left:2rem;\n}\n.upArrow-lexus {\n    background-image: url(\"../../assets/images//upArrow-lexus.png\");\n    background-repeat:no-repeat;\n    display:inline-block;\n}\n.upArrow-toyota {\n    background-image: url(\"../../assets/images//T_Artboard 21mdpi.png\");\n    background-repeat:no-repeat;\n    display:inline-block;\n}\n\n.downArrow-toyota {\n    background-image: url(\"../../assets/images//q_down.png\");\n    background-repeat:no-repeat;\n    display:inline-block;\n}\n\n.downArrow-lexus {\n    background-image: url(\"../../assets/images//downArrow-lexus.png\");\n    background-repeat:no-repeat;\n    display:inline-block;\n}\n\n.down-icon-toyota{\n    background-image: url(\"../../assets/images//T_Artboard 21mdpi.png\");\n    background-repeat:no-repeat;\n    padding:0.2px;\n    height: 29px;\n    width: 28px;\n    display:inline-flex;\n}\n.down-icon-lexus{\n    background-image: url(\"../../assets/images//upArrow-lexus.png\");\n    background-repeat:no-repeat;\n    padding:0.2px;\n    height: 29px;\n    width: 28px;\n    display:inline-flex;\n}\n\n.selectedButton-toyota{\n    background-image: url(\"../../assets/images//T_Artboard 21mdpi.png\");\n    background-repeat:no-repeat;\n    transform: rotate(180deg);\n\tcursor: pointer;\n    padding:0.2px;\n    height: 29px;\n    width: 28px;\n    display:inline-flex;\n}\n.selectedButton-lexus{\n    background-image: url(\"../../assets/images//upArrow-lexus.png\");\n    background-repeat:no-repeat;\n    transform: rotate(180deg);\n\tcursor: pointer;\n    padding:0.2px;\n    height: 29px;\n    width: 28px;\n    display:inline-flex;\n}\n\n.buttonHeading-toyota {\n    background-color: #e50000;\n    border: 1px solid #e50000;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    height: 1.2rem;\n    width: 5rem;\n    margin-left:2rem;\n  }\n  \n  .buttonHeading-lexus {\n    background-color: #252525;\n    border: 1px solid #252525;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    height: 1.2rem;\n    width: 5rem;\n    margin-left:2rem;\n  }\n\n  .buttonHeadingWhat-toyota {\n    background-color: #e50000;\n    border: 1px solid #e50000;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    margin-left:0rem;\n    margin-top:0.7rem;\n    width: 5rem;\n    float:left;\n  }\n  \n  .buttonHeadingWhat-lexus {\n    background-color: #252525;\n    border: 1px solid #252525;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    margin-left:0rem;\n    margin-top:0.7rem;\n    width: 5rem;\n    float:left;\n  }\n\n.edit-icon {\n    background-image: url(\"../../assets/images//edit.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float:right;\n    \n}\n\n.subQuestionSection {\n    margin-top:1.5rem;\n    margin-bottom:-1.55rem;\n}\n.subQuestionAdd {\n    background-image: url(\"../../assets/images//Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    background-position: center;\n    float:right;\n}\n.mainQueAdd {\n    background-image: url(\"../../assets/images//Artboard 4.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    /* display:inline-block; */\n    float:right;\n\n}\n.mainQuestionnaire {\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    display:inline-block;\n    padding:1rem;\n\n}\n.delete-icon {\n    background-image: url(\"../../assets/images//delete.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float:right;\n    \n}\n.delete-iconRight {\n    background-image: url(\"../../assets/images//delete.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    display:inline-block;\n    float:right;\n    padding:1rem;\n}\n.edit-iconRight {\n    background-image: url(\"../../assets/images//edit.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    display:inline-block;\n    /* margin-left:90%; */\n    float:right;\n    padding:1rem;\n}\n\n.questionTitle {\n    font-weight:bold;\n    margin-top:1rem;\n    word-break:normal;\n}\n\n.whySection, .librarySection {\n    margin-bottom:1rem;\n    margin-left:1.5rem;\n}\n\n.collapseContainer {\n    margin-left:2rem;\n    margin-right:1rem;\n    margin-top:1rem;\n    margin-bottom:1rem;\n    white-space: pre-wrap;\n}\n\n.collapseContainerLibrary {\n    margin-top:1rem;\n    white-space: pre-wrap;\n}\n\n.libraryLinkContainer {\n    max-height:8rem;\n    overflow-y:scroll;\n}\n\n\n.linkLibraryModal {\n    min-height:412px;\n}\n\n.noOfFiles {\n    margin-right:7rem !important;\n    margin-bottom:37px;\n    display:block !important;\n}\n\n.questionnaire {\n    background-color:white;\n    /* max-height:500px; */\n}\n.rotate-false{\n    transform: rotate(0deg) !important;\n}\n.rotate-true{\n    transform: rotate(90deg) !important;\n}\n.questionSummary {\n    height:100%;\n}\n.questionSummary .treeBeardContainter ul{\n    background-color: white !important;\n    color:black ;\n    font-size: 12px !important;\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n.questionSummary .treeBeardContainter ul li div {\n    background-color: white !important;\n    color:black ;\n    font-size: 12px !important;\n    font-family: Arial, Helvetica, sans-serif;\n    /* display:block; */\n    height: 100%;\n\n}\n.activeQuestion{\n      color:#e50000 !important;\n}\n.treeBeardContainter{\nword-wrap: break-word;\nheight: 93%;\n\n}\n#leftPaneModal .modal-content{\n      width: 400px !important;\n}\n.questionSummary ul li{\n    margin:15px 10px;\n}\n/* .leftNavCollapseBtn:hover,.thickRightBorder div.d-flex:hover{\n    background-color: #f0f0f0 !important;\n}  */\n.subQueAdd {\n    padding-top:2rem;\n}\n.leftNavCollapseBtn-toyota{\n    background-image: url(\"../../assets/images//collapsebtn-toyota.png\");\n    background-color: white; \n    height: 100%;\n    cursor: pointer;\n    width:14px;\n    background-repeat: no-repeat;\n    /* margin-left:5px; */\n    border:solid 1px #ececec;\n    background-position: center;\n   \n}\n.leftNavCollapseBtn-lexus{\n    background-image: url(\"../../assets/images//collapsebtn-lexus.png\");\n    background-color: white; \n    height: 100%;\n    cursor: pointer;\n    width:14px;\n    background-repeat: no-repeat;\n    /* margin-left:5px; */\n    border:solid 1px #ececec;\n    background-position: center;\n   \n}\n.mainQuestionTools {\n    /* margin-top:0.5rem; */\n    height:30px;\n    padding:5px;\n    margin-bottom:-0.1rem;\n}\n.prevQuestion-toyota {\n    background-image: url(\"../../assets/images//prevPage.png\");\n    height: 18px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n    float:right;\n    padding:1rem;\n}\n.prevQuestion-lexus {\n    background-image: url(\"../../assets/images//prevPage-lexus.png\");\n    height: 18px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n    float:right;\n    padding:1rem;\n}\n.nextQuestion-toyota {\n    background-image: url(\"../../assets/images//nextPage.png\");\n    height: 18px;   \n    background-position: center;\n    background-repeat: no-repeat;\n    margin-left: 5rem;;\n    float:right;\n    padding:1rem;\n}\n.nextQuestion-lexus {\n    background-image: url(\"../../assets/images//nextPage-lexus.png\");\n    height: 18px;   \n    background-position: center;\n    background-repeat: no-repeat;\n    margin-left: 5rem;;\n    float:right;\n    padding:1rem;\n}\n\n.prevQuestion-disabled-toyota {\n    background-image: url(\"../../assets/images//prevPage.png\");\n    height: 18px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n    float:right;\n    padding:1rem;\n    cursor:not-allowed;\n}\n\n.nextQuestion-disabled-toyota {\n    background-image: url(\"../../assets/images//nextPage.png\");\n    height: 18px;   \n    background-position: center;\n    background-repeat: no-repeat;\n    margin-left: 5rem;;\n    float:right;\n    padding:1rem;\n    cursor:not-allowed;\n}\n.prevQuestion-disabled-lexus {\n    background-image: url(\"../../assets/images//prevPage-lexus.png\");\n    height: 18px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n    float:right;\n    padding:1rem;\n    cursor:not-allowed;\n}\n\n.nextQuestion-disabled-lexus {\n    background-image: url(\"../../assets/images//nextPage-lexus.png\");\n    height: 18px;   \n    background-position: center;\n    background-repeat: no-repeat;\n    margin-left: 5rem;;\n    float:right;\n    padding:1rem;\n    cursor:not-allowed;\n}\n.questionnaire .leftPane{\n    padding-right: 0px !important;\n}\n\n#leftPaneModal {\n    color:black;\n}\n#leftPaneModal .modal-header{\n    background-color:#e50000;\n}\n\n.questionSummaryAction{\n    height: 30px;\n    border-bottom: 1px solid #e5e5e5;    \n    padding:5px;\n    /* width: 178px; */\n\n}\n.nmscTabs{\n    padding : 0rem !important;\n    border-width : 0px;\n    font-size : 0.75rem;\n    position: relative;\n    width: 100%\n}\n.mainQueAddDisabled {\n    background-image: url(\"../../assets/images//Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    cursor:not-allowed;\n    background-position: center;\n    float:right;\n    padding:1rem;\n}\n\n\n.TrailUL {\n    column-count : 2;\n    column-gap :0;\n    list-style-type: none;\n    margin-left:-1.5rem;\n}\n\n.TrailUL li {\n    /* display: inline-block; */\n}\n\n.emptyDiv {\n    min-height :430px !important;\n}\n\n.tableCount {\n    /* background-color: #e6e6e6; */\n    background-repeat: no-repeat;\n    /* background-image: -webkit-linear-gradient(#ffffff, #ffffff 25%, #e6e6e6);\n  background-image: linear-gradient(#ffffff, #ffffff 25%, #e6e6e6); */\n    color: #202020;\n    font-size: 12px;\n    line-height: normal;\n    font-weight: normal;\n    text-align: center;\n    font-weight: bold;\n    border-collapse: initial !important;\n    border: none !important;\n   }\n/* .tmeTable thead > tr > th:first-child {\n    width:3rem !important;\n} */\n.tableCount th{\n    font-size: 12px;\n    border: none !important;\n    padding-bottom: none !important;\n    padding-top: none !important;\n}\n\n.tableCount tr{\n    font-size: 12px;\n    border: none !important;\n}\n.libLinkRightPanel {\n    width: 62%;\n    /* border: 1px solid lightgrey; */\n    min-height: 400px!important;\n}\n.viewLibraries {\n    padding:1rem;\n    border: 0.5px solid lightgrey;\n}\n.nmscTabs .nav-tabs .nav-item{\n    width:18% !important;\n}\n\n.nmscTabs.toyota .nav-tabs .nav-item a{\n    border-color:transparent !important;\n    color:black!important;\n}\n\n.nmscTabs.toyota .nav-tabs .nav-item a.nav-link.active{    \n    color:#e50000 !important;    \n}\n\n.nmscTabs.lexus .nav-tabs .nav-item a{\n    border-color:transparent !important;\n}\n\n.nmscTabs.lexus .nav-tabs .nav-item a.nav-link.active{\n    color:black !important;\n}\n\n.nmscTabs .nav-tabs li.nav-item:first-child {\n    width:35% !important;\n}\n\n\n/* .leftPane.leftNav{\n    height:604px !important;\n}\n.rightPane{\n    height:604px !important; \n}\n.kpiTableContainer .tabs .nav.nav-tabs{\n    height:36px !important;\n} */\n/* .publishPanel{\n    position: absolute;\n    width: 100%;\n    bottom: 23px;\n} */\n/* .rightPane{\n    position: relative;\n    min-height: 779px\n}\n.leftPane .leftNav{\n    min-height: 779px\n}\n.questionSummary{\n    min-height: 770px;\n} */\n/* mainQuestionContent-isNmsc{\n    min-height: 900px;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
